export default "__VITE_ASSET__b345c4e3__"